<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

    import {getSiteId} from "@/assets/js/api";

    export default {

      name: 'App',
      // metaInfo:{
      //   title:localStorage.getItem('siteName')==null?'继续教育':localStorage.getItem('siteName'),
      //   meta:[
      //
      //   ]
      // },
      metaInfo () {
        return {
          title: this.siteName
        }
      },
      data(){
        return{
          siteName:undefined
        }
      },
      // beforeCreate() {
      //   this.getSite();
      // },
      // created() {
      //   this.getSite();
      // },
      mounted() {
          this.getSite();
            window.onload = function () {
// console.log(window.sessionStorage["ISlogin"]);
                if (!window.sessionStorage["ISlogin"]) {
// 关闭浏览器
                    window.localStorage.removeItem("userInfo");
                } else {
// 刷新
                }
            };
            window.onunload = function () {
                window.sessionStorage["ISlogin"] = true;
            };
            window.onbeforeunload = function () {
                window.sessionStorage["ISlogin"] = true;
            };
        },
      methods: {
        getSite() {
          // getSiteId('humc.hnzkw.org.cn').then((res) => {
          getSiteId(document.domain).then((res) => {
            this.siteName = res.data.siteName
            localStorage.setItem("siteName",res.data.siteName)


          });
        },
      }
    }
</script>




<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  min-width: 1200px;
}
img {
  width: 100%;
  height: 100%;
}
input{
  border: 0;
  background-color: transparent;
}
textarea{
  border: 0;
}
.flex{
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.flex1{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex2{
  display: flex;
  align-items: center;
}
</style>
